import {uiGameManager} from '../../EntryShared.ts'
import {type GameColor} from '../../GameColor.ts'
import {PIXI} from '@colonist/pixi'

export class UIGameToolTipPointerView extends PIXI.Graphics {
    private readonly backgroundColor: GameColor.Color
    private readonly itemSize = uiGameManager.canvasController.itemSize
    private readonly w

    private readonly container: PIXI.Container
    private readonly viewToPlaceNear: PIXI.Container | PIXI.Sprite
    private readonly toolTipCornerRadius: number

    constructor(container: PIXI.Container, x: number, viewToPlaceNear: PIXI.Container | PIXI.Sprite, toolTipCornerRadius: number, backgroundColor: GameColor.Color) {
        super()
        this.backgroundColor = backgroundColor
        this.w = this.itemSize / 4

        this.container = container
        this.viewToPlaceNear = viewToPlaceNear
        this.toolTipCornerRadius = toolTipCornerRadius

        const toolTipIsAboveView = this.viewToPlaceNear.getGlobalPosition().y > this.container.getGlobalPosition().y
        const y = toolTipIsAboveView ? container.height : 0
        this.drawToolTipPointer(this.clampX(x), y, toolTipIsAboveView)
        container.addChild(this)
    }

    clampX(x: number) {
        const margin = this.toolTipCornerRadius + this.w / 2
        const leftLimit = margin
        const rightLimit = uiGameManager.canvasController.appW - margin
        return Math.min(Math.max(x, leftLimit), rightLimit)
    }

    private drawToolTipPointer(x: number, y: number, pointDown: boolean = true) {
        const h = pointDown ? this.itemSize / 8 : -this.itemSize / 8

        const trianglePoints = [
            x - this.w / 2, y,
            x + this.w / 2, y,
            x, y + h,
        ]

        this.beginFill(this.backgroundColor)
        this.drawPolygon(trianglePoints)
        this.endFill()
    }
}
